const CACHE_KEY = 'pedidosAtivosCache';

export function readPedidosCache(idEntregador) {
  try {
    const cache = JSON.parse(localStorage.getItem(CACHE_KEY) || 'null');
    if (!cache || String(cache.id_entregador) !== String(idEntregador)) return null;
    if (!Array.isArray(cache.pedidos)) return null;
    return cache;
  } catch (error) {
    return null;
  }
}

export function writePedidosCache({ idEntregador, pedidos, sincronizadoEm }) {
  try {
    localStorage.setItem(CACHE_KEY, JSON.stringify({
      id_entregador: idEntregador,
      pedidos,
      sincronizado_em: sincronizadoEm
    }));
  } catch (error) {
    return false;
  }

  return true;
}

export function clearPedidosCache() {
  localStorage.removeItem(CACHE_KEY);
}
